import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';

export const XAxis = styled.g`
    font-size: 14px;
    letter-spacing: 0.5px;
`;
export const XAxisGroup = styled.g``;
export const XAxisLabel = styled.text`
    font-size: 16px;
    fill: ${Variables.Colors.n50};
    letter-spacing: 0.5px;
`;
